<iframe
  width="100%"
  frameborder="0"
  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
  allowfullscreen
  [src]="youtubeEmbedUrl()"
  [attr.height]="maxHeight() || 360"
></iframe>
